export const SHIPMENT_CARRIERS = ["UPS", "FedEx"];

// Backend matches carriers case-insensitively; stored values may be free text from before validation.
export const toShipmentCarrier = (value?: string | null): string =>
  SHIPMENT_CARRIERS.find((carrier) => carrier.toLowerCase() === value?.trim().toLowerCase()) ?? "";
